export const legalTranslations = {
  title: "Legal Notice",
  description: "Legal notice and company information for Leadsme. Contact details, SIREN number, hosting provider and editorial responsibility.",
  content: `1. Website Publisher
The Leadsme website is published by:
- First and Last Name: DUHR Romain
- Status: Individual Entrepreneur (EI)
- Trade Name: Leadsme

2. Address
Headquarters / Professional Address:
- 220B rue du Buisson, 59700 Marcq-en-Barœul, France

3. Contact
Email Address: contact@leadsme.app
Contact Form: accessible via the contact page on the website

4. Registration
SIREN: 889 784 864

5. VAT
VAT not applicable, article 293B of the French General Tax Code.

6. Publication Director
DUHR Romain, as publisher of the Leadsme website.

7. Hosting
The website is hosted by:
- Host: Amazon Web Services (AWS)
- Region: eu-west-3 (Paris)
- Website: https://aws.amazon.com`,
  lastUpdate: "January 9, 2026",
} as const;